export default __webpack_public_path__ + "static/media/ato6.0d3f8329.svg";